import * as React from 'react';
/**
 *
 * Original name: calendar
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A539
 *
 */
export const CalendarSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M13 22v63a13.015 13.015 0 0 0 13 13h68a13.015 13.015 0 0 0 13-13V22H13Zm88 6v9H19v-9h82Zm-7 64H26a7.008 7.008 0 0 1-7-7V43h82v42a7.006 7.006 0 0 1-7 7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M44 55a3.715 3.715 0 0 0-4 4 3.715 3.715 0 0 0 4 4 3.715 3.715 0 0 0 4-4 3.715 3.715 0 0 0-4-4Zm16 0a3.715 3.715 0 0 0-4 4 4 4 0 1 0 8 0 3.715 3.715 0 0 0-4-4Zm16 0a3.714 3.714 0 0 0-4 4 4 4 0 1 0 8 0 3.715 3.715 0 0 0-4-4ZM44 71a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm16 0a4 4 0 1 0 4 4 3.714 3.714 0 0 0-4-4Zm16 0a4 4 0 1 0 4 4 3.714 3.714 0 0 0-4-4Z", fill: "currentColor" })));
